import React from "react";
import Slider from "react-slick";
import { NftCard } from "../Products/NftCard/NftCard";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowsLeft, ArrowsRight } from "./Arrows/Arrows";
import { SliderTitle, SliderWrapper } from "./ProductSlider.styled";
import { CollectionCard } from "../Products/CollectionCard/CollectionCard";

export const ProductSlider = ({
  title,
  titleIcon,
  products,
  collection = false,
}) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <ArrowsRight />,
    prevArrow: <ArrowsLeft />,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <SliderWrapper>
      <div className='container'>
        {title && (
          <SliderTitle>
            {title} {titleIcon && <img src={titleIcon} alt='icon' />}
          </SliderTitle>
        )}
        <Slider {...settings}>
          {products.map((product, i) =>
            !collection ? (
              <NftCard product={product} key={i} />
            ) : (
              <CollectionCard product={product} key={i} />
            )
          )}
        </Slider>
      </div>
    </SliderWrapper>
  );
};
